import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination,
  TableSortLabel,
} from '@material-ui/core';

import {
  Search as SearchIcon,
} from 'react-feather';

import { SIREN_CONFIG } from 'config.js';
import { connect, useSelector} from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  updateQueryRoomId,
  updateQueryRoomName
} from 'actions/query';

import { getRoomTypeLabel } from 'utils/RoomType';
import { loadCaregiverList, getCaregiverName } from "utils/LoadConfiguration";
import { FormattedMessage, useIntl } from "react-intl";


const COLUMN_WIDTH = {
  NO: '5%',
  ROOM_ID: '20%',
  ROOM_NAME : '20%',
  ROOM_TYPE : '10%',
  // CAREGIVER1_ID : '20%', //66
  // CAREGIVER2_ID : '20%', //71
}



function descendingComparator(a, b, orderBy) {

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}


function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


const headCells = [
  {
    id: 'no',
    numeric: false,
    disablePadding: true,
    width:COLUMN_WIDTH.NO,
    label: 'No',
  },
  {
    id: 'roomId',
    numeric: false,
    disablePadding: false,
    width:COLUMN_WIDTH.ROOM_ID,
    // label: '룸ID',
    label: <FormattedMessage id="room_id" />,
  },
  {
    id: 'roomName',
    numeric: false,
    disablePadding: false,
    width:COLUMN_WIDTH.ROOM_NAME,
    // label: '병실',
    label: <FormattedMessage id="room_name" />,
  },
  {
    id: 'roomType',
    numeric: false,
    disablePadding: true,
    width:COLUMN_WIDTH.ROOM_TYPE,
    // label: '룸유형',
    label: <FormattedMessage id="room_type" />,
  },
  // {
  //   id: 'caregiver1_id',
  //   numeric: false,
  //   disablePadding: false,
  //   width:COLUMN_WIDTH.CAREGIVER1_ID,
  //   label: '주담당자',
  // },
  // {
  //   id: 'caregiver2_id',
  //   numeric: false,
  //   disablePadding: false,
  //   width:COLUMN_WIDTH.CAREGIVER2_ID,
  //   label: '부담당자',
  // },
];


function EnhancedTableHead(props) {
  const { order, orderBy, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'center'}
            align='center'
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            width={headCell.width}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {/* {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null} */}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};


const RoomTable = props => {
  const { className, users, queryRoomParams, ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();


  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('no');


  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);

  const [queryRoomId, setQueryRoomId] = useState('');
  const [queryRoomName, setQueryRoomName] = useState('');

  const [caregiverList, setCaregiverList] = useState([]);
  const facility_id = useSelector((store) => store.user.facility_id);

  const searchData = (roomId, roomName) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/room/roomList?facility_id=${facility_id}&`;

    var params = '';
    if (roomId) {
      params = 'roomId=' + roomId;
    }

    if (roomName) {
      params += params.length > 0 ? '&' : '';
      params += 'roomName=' + roomName;
    }

    url += params;

    fetch(url)
      .then(res => res.json())
      .then(snapshot => {

        var list = [];
        var idx = 1;
        if (snapshot.resultData != null) {
          snapshot.resultData.forEach(doc => {
            doc.no = idx++;
            list.push(doc);
          });
        }
        setListData(list);
      }
      );
  }


  useEffect(() => {

    async function loadCaregiverInfo(){
      setCaregiverList( await loadCaregiverList(facility_id ) );
    }
    loadCaregiverInfo();

    //3중 하나 이상의 파라미터값이 있다면, 자동검색하여 화면에 그 결과를 표시하여, UX를 향상시킴.
    if (queryRoomParams.roomQueryRoomId || queryRoomParams.roomQueryRoomName) {
      searchData(queryRoomParams.roomQueryRoomId, queryRoomParams.roomQueryRoomName);
    }

    setQueryRoomId(queryRoomParams.roomQueryRoomId);
    setQueryRoomName(queryRoomParams.roomQueryRoomName);

    return () => { };
  }, []);



  const handleSearch = event => {
    searchData(queryRoomId, queryRoomName);
  }


  /**
   * 검색 정보 지우기
   * @param {*} event
   */
  const handleClear = event => {
    props.updateQueryRoomId('');
    props.updateQueryRoomName('');
    setQueryRoomId('');
    setQueryRoomName('');
  }

  const handleQueryRoomId = (event) => {
    setQueryRoomId(event.target.value);
    props.updateQueryRoomId(event.target.value);
  }

  const handleQueryRoomName = (event) => {
    setQueryRoomName(event.target.value);
    props.updateQueryRoomName(event.target.value);
  }

  const keyUp = (event) => {

    if (event.key === "Enter"){
      handleSearch();
      event.preventDefault();
    }
  }

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  const startRow = (page * rowsPerPage);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  return (

    <Card className={clsx(classes.root, className)} {...rest} >

      <Box m={1} p={2}>

        <Box mt={2}
          display="flex"
          alignItems="center"
          justifyContent="start"
          flexGrow={1}>

          <TextField className={classes.queryField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                </InputAdornment>
              )
            }}

            onChange={handleQueryRoomId}
            label={formatMessage({id:'room_id'})}
            placeholder={formatMessage({id:'room_id'})}
            value={queryRoomId}
            variant="outlined"
            onKeyUp={keyUp}
          />

          <TextField className={classes.queryField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                </InputAdornment>
              )
            }}

            onChange={handleQueryRoomName}
            label={formatMessage({id:'room_name'})}
            placeholder={formatMessage({id:'room_name'})}
            value={queryRoomName}
            variant="outlined"
            onKeyUp={keyUp}
          />

          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.bulkAction}
            onClick={handleSearch}
          >
            <FormattedMessage id="search" />
          </Button>

          <Button
            variant="outlined"
            size="large"
            className={classes.bulkAction}
            onClick={handleClear}
          >
            <FormattedMessage id="initialize" />
          </Button>
        </Box>
      </Box>

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>

              <EnhancedTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={listData.length}
              />

              <TableBody>
                {/* {listData.slice(0 + startRow, rowsPerPage + (page * rowsPerPage)).map(module => ( */}
                { stableSort(listData, getComparator(order, orderBy)).slice(0 + startRow, rowsPerPage + (page * rowsPerPage)).map(module => (

                  <TableRow
                    className={classes.tableRow}
                    key={module.roomId}
                    component={RouterLink} to={`/rooms/update/${module.roomId}`}
                  >

                    <TableCell width={COLUMN_WIDTH.NO} align="center">{module.no}</TableCell>
                    <TableCell width={COLUMN_WIDTH.ROOM_ID} align="center">
                        <Typography variant="body1">{module.roomId}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.ROOM_NAME} align="center">{module.roomName}</TableCell>
                    <TableCell width={COLUMN_WIDTH.ROOM_TYPE} align="center">{getRoomTypeLabel(module.roomType)}</TableCell>
                    {/* <TableCell width={COLUMN_WIDTH.CAREGIVER1_ID} align="center">{getCaregiverName(module.caregiver1_id)}</TableCell>
                    <TableCell width={COLUMN_WIDTH.CAREGIVER2_ID} align="center">{getCaregiverName(module.caregiver2_id)}</TableCell> */}
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

RoomTable.propTypes = {
  className: PropTypes.string,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateQueryRoomId,
    updateQueryRoomName
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    queryRoomParams: state.queryRoomParams
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RoomTable));


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight: 20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));
